/*
 * @Description:
 * @Author: pliybird
 * @Date: 2022-01-23 16:17:16
 * @LastEditTime: 2025-10-16 13:44:49
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/scss/bootstrap.scss";
import "animate.css";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import "./assets/scss/style.scss";
import "bootstrap";
import CoolLightBox from "vue-cool-lightbox";
// import VueScrollActive from 'vue-scrollactive'
import AOS from "aos";
import "aos/dist/aos.css";
// import VueTypedJs from 'vue-typed-js'
import i18n from "./lang";
import "@/assets/fonts/iconfont.js";
Vue.config.productionTip = false;
Vue.use(CoolLightBox);

// Vue.use(VueScrollActive) // 2025年10月14日注释全局导入，该库压缩生产包有bug，改用局部导入避免
// 正式环境清除所有console.log
if (process.env.NODE_ENV === "production") {
  if (window) {
    window.console.log = function () {};
  }
}
new Vue({
  router,
  created() {
    AOS.init({
      duration: 800,
      once: true,
    });
  },
  i18n,
  render: (h) => h(App),
}).$mount("#app");
